import { Component, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AggregationResult } from '../../model/everything-search-result';
import { AggregationKeyValuePipe } from '../../pipe/aggregation-key-value.pipe';
import { SourcePipe } from '../../pipe/source.pipe';
import { KeyValueCount } from '../../utils/key-value-count';
import { SearchFilterValueListComponent } from '../search-filter-value-list/search-filter-value-list.component';

@Component({
  selector: 'app-search-filter-source',
  templateUrl: './search-filter-source.component.html',
  styleUrls: [ './search-filter-source.component.scss' ],
  imports: [ SearchFilterValueListComponent, AggregationKeyValuePipe ]
})
export class SearchFilterSourceComponent {
  @Input() aggregation: AggregationResult[];
  @Output() visible = new BehaviorSubject<boolean>(false);
  keyValues: KeyValueCount[] = [];
  pipe = new SourcePipe();
}
